import { supabase } from "./supabase";

export class ApiError extends Error {
  constructor(public status: number, message: string) {
    super(message);
  }
}

export async function api<T = unknown>(path: string, opts?: RequestInit): Promise<T> {
  const headers: Record<string, string> = { ...(opts?.headers as Record<string, string> | undefined) };
  if (opts?.body && !headers["Content-Type"]) {
    headers["Content-Type"] = "application/json";
  }

  const res = await fetch(path, {
    credentials: "same-origin",
    ...opts,
    headers,
  });

  if (res.status === 401) {
    await supabase.auth.signOut();
    const redirect = encodeURIComponent(location.pathname + location.search);
    window.location.href = `/login?redirect=${redirect}`;
    throw new ApiError(401, "Session expired");
  }

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new ApiError(res.status, (data as { error?: string }).error || `Request failed: ${res.status}`);
  }

  return res.json();
}
